module.exports = __webpack_public_path__ + "img/2025-12_commencement.392398d0.webp";